import { BuDB, withFirestore, withLocalStorage } from "@budb";
import { PROFILE_STORE, TimeStore } from "@gazebo/mobx";
import PouchDB from "pouchdb";
import PouchDBFind from "pouchdb-find";
import React, { createContext, useContext, useMemo } from "react";
import { NotebookStore } from "./NotebookStore";

export class RootStore {
  public readonly timeStore: TimeStore;
  public readonly notebookStore: NotebookStore;

  constructor() {
    PouchDB.plugin(PouchDBFind);
    const pouchDB = new PouchDB("notegarden");
    const budb = withFirestore(
      withLocalStorage(new BuDB(pouchDB)),
      PROFILE_STORE
    );
    this.timeStore = new TimeStore();
    this.notebookStore = new NotebookStore(this.timeStore, budb);
  }
}

// https://github.com/vercel/next.js/blob/master/examples/with-mobx/store.js
let store: RootStore | undefined;

function initializeStore(initialData = null) {
  const _store = store ?? new RootStore(/* initialData */);

  // If your page has Next.js data fetching methods that use a Mobx store, it will
  // get hydrated here, check `pages/ssg.js` and `pages/ssr.js` for more details
  if (initialData) {
    // _store.hydrate(initialData)
  }

  // For SSG and SSR always create a new store
  if (typeof window === "undefined") {
    return _store;
  }
  // Create the store once in the client
  if (!store) {
    store = _store;
  }

  return _store;
}

export const RootStoreProvider: React.FC<{}> = ({ children }) => {
  const store = useMemo(() => initializeStore(), []);

  return <Provider value={store}>{children}</Provider>;
};

const RootStoreContext = createContext<RootStore | null>(null);

const Provider = RootStoreContext.Provider;

export const useRootStore = (): RootStore => {
  const c = useContext(RootStoreContext);

  if (!c) {
    throw new Error("Invalid Context: Missing Root Store");
  }

  return c;
};

export const useNotebookStore = (): NotebookStore => {
  return useRootStore().notebookStore;
};
